import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { theme } from '../../theme';
import { CATEGORIES } from '../../constants';

export function LandingScreen({ onNavigate }) {
  const { isAuthenticated, login } = useAuth();

  return (
    <div style={{ padding: '24px 16px' }}>
      {/* Hero */}
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h1 style={{
          fontSize: '28px',
          fontWeight: 800,
          color: theme.text,
          marginBottom: '12px',
          lineHeight: 1.2,
        }}>
          Viltu láta <span style={{ color: theme.accent }}>búa til</span> eitthvað?
        </h1>
        <p style={{
          fontSize: '15px',
          color: theme.textSecondary,
          lineHeight: 1.5,
          maxWidth: '320px',
          margin: '0 auto',
        }}>
          Finndu maker í nágrenninu. 3D prentun, laser, CNC, handverk og fleira — fáðu tilboð á mínútum.
        </p>
      </div>

      {/* CTA Buttons */}
      <div style={{ display: 'flex', gap: '12px', marginBottom: '32px' }}>
        <button
          onClick={() => isAuthenticated ? onNavigate('new-request') : login()}
          style={{
            flex: 1,
            background: theme.accent,
            color: '#000',
            border: 'none',
            padding: '14px',
            borderRadius: theme.radius,
            fontWeight: 700,
            fontSize: '15px',
            cursor: 'pointer',
          }}
        >
          Fá tilboð
        </button>
        <button
          onClick={() => onNavigate('browse')}
          style={{
            flex: 1,
            background: theme.bgCard,
            color: theme.text,
            border: `1px solid ${theme.border}`,
            padding: '14px',
            borderRadius: theme.radius,
            fontWeight: 600,
            fontSize: '15px',
            cursor: 'pointer',
          }}
        >
          Skoða makers
        </button>
      </div>

      {/* Category Grid */}
      <h2 style={{
        fontSize: '16px',
        fontWeight: 700,
        color: theme.text,
        marginBottom: '16px',
      }}>
        Þjónustuflokkar
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px',
        marginBottom: '32px',
      }}>
        {CATEGORIES.map(cat => (
          <button
            key={cat.id}
            onClick={() => onNavigate('browse', cat.id)}
            style={{
              background: theme.bgCard,
              border: `1px solid ${theme.border}`,
              borderRadius: theme.radius,
              padding: '16px 12px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              cursor: 'pointer',
              textAlign: 'left',
            }}
          >
            <span style={{ fontSize: '24px' }}>{cat.icon}</span>
            <span style={{ fontSize: '14px', color: theme.text, fontWeight: 500 }}>
              {cat.label}
            </span>
          </button>
        ))}
      </div>

      {/* How it works */}
      <h2 style={{
        fontSize: '16px',
        fontWeight: 700,
        color: theme.text,
        marginBottom: '16px',
      }}>
        Hvernig virkar þetta?
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {[
          { step: '1', title: 'Sendu beiðni', desc: 'Lýstu því sem þú vilt láta búa til — hlaðið upp mynd eða STL skrá' },
          { step: '2', title: 'Fáðu tilboð', desc: 'Makers í nágrenninu senda tilboð með verði og afhendingartíma' },
          { step: '3', title: 'Samþykktu og greiddu', desc: 'Veldu besta tilboðið og greiddu á öruggan hátt' },
          { step: '4', title: 'Sæktu eða fáðu sent', desc: 'Sæktu tilbúna vöru eða fáðu hana senda' },
        ].map(item => (
          <div key={item.step} style={{
            background: theme.bgCard,
            border: `1px solid ${theme.border}`,
            borderRadius: theme.radius,
            padding: '16px',
            display: 'flex',
            gap: '14px',
          }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              background: theme.accentBg,
              color: theme.accent,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 700,
              fontSize: '14px',
              flexShrink: 0,
            }}>
              {item.step}
            </div>
            <div>
              <div style={{ fontWeight: 600, color: theme.text, marginBottom: '4px', fontSize: '14px' }}>
                {item.title}
              </div>
              <div style={{ fontSize: '13px', color: theme.textSecondary, lineHeight: 1.4 }}>
                {item.desc}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
